import { itemConstants } from "../../constants";
import { itemService } from "../../services";
import { alertActions } from "../alert.actions";

export const itemActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    itemService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: itemConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: itemConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: itemConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, nick_name, status, weight_id) {
  return (dispatch) => {
    dispatch(request(name, nick_name, status, weight_id));

    itemService.addParameter(name, nick_name, status, weight_id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: itemConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: itemConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: itemConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, nick_name, status, weight_id) {
  return (dispatch) => {
    dispatch(request(id, name, nick_name, status, weight_id));

    itemService.updateParameter(id, name, nick_name, status, weight_id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: itemConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: itemConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: itemConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    itemService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: itemConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: itemConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: itemConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: itemConstants.CLEAR };
}
